<template>
  <tr class="ArticleProgress">
    <td class="ellipsis">
      <Field
        class="selectCheckbox"
        type="checkbox"
        :value="isSelected"
        @update:value="$emit('select', $event)" />
      <Route v-if="article.siteId" :id="article.siteId" to="Site">
        {{ siteName }}
      </Route>
    </td>
    <td class="ellipsis">
      <Route :id="article.id" to="Article">
        {{ article.topic | fallback }}
      </Route>
    </td>
    <td class="ellipsis">
      {{ category | fallback }}
    </td>
    <td>
      <Field
        v-if="status"
        class="xs"
        :disabled="isPatching"
        :options="articleStatuses"
        type="select"
        :value="article.status"
        @update:value="patchStatus" />
    </td>
    <td>
      <MetaProgresss
        :article="article"
        @update:fields="patchArticle" />
    </td>
    <SectionProgress
      v-for="{ sectionTemplateId } in columns"
      :key="sectionTemplateId"
      :article="article"
      :sectionTemplateId="sectionTemplateId" />
    <td>
      <ProductProgress
        :article="article"
        :articleLaptops="articleLaptops" />
    </td>
    <td>
      <RecordActions
        :doShowDelete="false"
        :doShowEdit="false"
        name="article"
        :record="article"
        routeName="Article">
        <a
          v-if="article.url"
          slot="after"
          class="Btn ib xs"
          :href="article.url"
          rel="noopener noreferrer"
          target="_blank">
          <Icon name="open" />
          <template v-if="article.publishedLastAt">
            {{ article.publishedLastAt | relativeTime }}
          </template>
        </a>
      </RecordActions>
    </td>
  </tr>
</template>

<script>
import { actions, getters } from '@utils'
import { ARTICLE_STATUS } from '@store/modules/article'
import MetaProgresss from './MetaProgresss'
import ProductProgress from './ProductProgress'
import RecordActions from '@components/RecordActions'
import SectionProgress from './SectionProgress'
import { propEq } from 'rambda'

export default {
  components: {
    MetaProgresss,
    ProductProgress,
    RecordActions,
    SectionProgress,
  },
  props: {
    article: { type: Object, required: true },
    columns: { type: Array, required: true },
    isSelected: { type: Boolean, default: false },
  },
  data() {
    return {
      isPatching: false,
    }
  },
  computed: {
    archArticle() {
      const { archArticleId } = this.article

      if (!archArticleId) return null

      return this
        .queryOne('article', archArticleId)
    },
    articleLaptops() {
      return this
        .query('articleLaptop', { articleId: this.article.id })
    },
    category() {
      return this.categories
        .find(propEq('value', this.article.category))
        ?.label
    },
    siteName() {
      return this
        .queryOne('site', this.article.siteId)
        ?.name
    },
    status() {
      return this.articleStatuses
        .find(propEq('value', this.article.status))
    },
    ...getters(
      'articleStatuses',
      'categories',
    ),
  },
  methods: {
    patchStatus(status) {
      return this.patchArticle({
        status,
        ...(status === ARTICLE_STATUS.POSTED && status !== this.article.status)
          ? { $doSyncRemote: true }
          : {},
      })
    },
    patchArticle(data) {
      return this.$wrap(
        () => this.PATCH_ARTICLE({
          id: this.article.id,
          ...data,
        }),
        'isPatching',
      )
    },
    ...actions('PATCH_ARTICLE'),
  },
}
</script>

<style lang="scss">
.ArticleProgress {
  td.ellipsis {
    @include ellipsis;
    max-width: 100px;
  }

  .Field-cont {
    margin: 0;
  }

  .selectCheckbox {
    display: inline-block;
  }
}
</style>
